import { render, staticRenderFns } from "./groupAllGoods.vue?vue&type=template&id=2f0f6c08&"
import script from "./groupAllGoods.vue?vue&type=script&lang=js&"
export * from "./groupAllGoods.vue?vue&type=script&lang=js&"
import style0 from "./groupAllGoods.vue?vue&type=style&index=0&id=2f0f6c08&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports